import { Routes } from '@angular/router';

export const weightLossRoutes: Routes = [
  {
    path: 'get-started',
    loadComponent: () => import('./get-started/get-started.page').then((m) => m.GetStartedPage),
    data: {
      background: 'assets/splash_intake.png',
    },
  },
  {
    path: 'no-access',
    loadComponent: () => import('./no-access/no-access.page').then((m) => m.NoAccessPage),
    data: {
      background: 'assets/splash_bck.jpg',
    },
  },
  {
    path: 'questionnaire',
    loadComponent: () => import('../../shared/pages/question/question.page').then((m) => m.QuestionPage),
    data: { flowType: 'weightLoss' },
  },
  {
    path: 'current-weight',
    loadComponent: () => import('../../shared/pages/weight/weight.page').then((m) => m.WeightPage),
    data: { flowType: 'weightLoss' },
  },
  {
    path: 'current-height',
    loadComponent: () =>
      import('./questionnaire-steps/current-height/current-height.page').then((m) => m.CurrentHeightPage),
  },
  {
    path: 'potential-weight',
    loadComponent: () =>
      import('./estimated-milestones/estimated-milestones.page').then((m) => m.EstimatedMilestonesPage),
  },
  {
    path: 'schedule-consultation',
    loadComponent: () =>
      import('./schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
  },
  {
    path: 'schedule-confirmation',
    loadComponent: () =>
      import('../../shared/pages/flow-schedule-confirmation/flow-schedule-confirmation.page').then(
        (m) => m.FlowScheduleConfirmationPage,
      ),
    data: { flowType: 'weightLoss' },
  },
  {
    path: 'plan-intro',
    loadComponent: () => import('./plan-intro/plan-intro.page').then((m) => m.PlanIntroPage),
  },
  {
    path: 'monthly-follow-up',
    loadComponent: () =>
      import('../monthly-checkin/monthly-follow-up/monthly-follow-up.page').then((m) => m.MonthlyFollowUpPage),
  },
  {
    path: 'monthly-summary',
    loadComponent: () =>
      import('../monthly-checkin/monthly-summary/monthly-summary.page').then((m) => m.MonthlySummaryPage),
  },
  {
    path: 'intake-checkpoint',
    loadComponent: () =>
      import('../weight-loss/intake-checkpoint/intake-checkpoint.component').then((m) => m.IntakeCheckpointComponent),
    data: {
      background: 'assets/splash_intake.png',
    },
  },
  {
    path: 'intake-confirmation',
    loadComponent: () =>
      import('../weight-loss/intake-confirmation/intake-confirmation.component').then(
        (m) => m.IntakeConfirmationComponent,
      ),
    data: {
      background: 'assets/splash_intake.png',
    },
  },
  {
    path: 'consent',
    loadComponent: () => import('../weight-loss/consent/consent.component').then((m) => m.ConsentComponent),
  },
  {
    path: 'capture-prescription',
    loadComponent: () =>
      import('../weight-loss/capture-prescription/capture-prescription.component').then(
        (m) => m.CapturePrescriptionComponent,
      ),
    data: {
      background: 'assets/splash_bck.jpg',
    },
  },
];
